module.exports = __webpack_public_path__ + "media/images/open_in_new_white-f4772e76f841dbd536ccae28d57890e0.svg";